export default __webpack_public_path__ + "static/media/alchemy-badge-dark.4c6c70fe.svg";